<div class="wrapper" *ngIf="items && items.length >0 && items[0].content">
    <div [innerHtml]="items[0].content | sanitizeHtml: 'HTML' "> </div>
</div>